import { render } from "./DesignText.vue?vue&type=template&id=2be32d54&scoped=true"
import script from "./DesignText.vue?vue&type=script&lang=js"
export * from "./DesignText.vue?vue&type=script&lang=js"

import "./DesignText.vue?vue&type=style&index=0&id=2be32d54&lang=css"
import "./DesignText.vue?vue&type=style&index=1&id=2be32d54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be32d54"]])

export default __exports__